import { 
  getAuditList
} from '../services';

export default {
  namespace: 'assetAudit',
  state: {
    
  },
  effects: {
    * getAuditList ({ payload }, { call }) {
      const result = yield call(getAuditList, payload);
      return result;
    },
  },
  reducers: {
    update (state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};